{
    "component-card-search-list.empty-state.title.non-final": "<strong>將此存放庫連結至軟體元件</strong>",
    "component-card.add-chat-channel": "新增聊天頻道",
    "component-card.chat-channels": "聊天頻道",
    "component-card.expander.show-more-link": "再多顯示 {formattedCount} 個"
}
